import { p } from './core.js'

// Categoria 5 — Armários Utilitários (R3)
// SKUs: ARM-MULT-A..B (2), ARM-VERT-A..D (4), SUSP-A..F (6), GEL-A..B (2), AS-A..D (4), WC-A..D (4) = 22
//
// Regra cor: armário fechado por porta → interior branco. Nichos abertos → cor.
// Moldura 6mm (L_MOLDURA = 0.05). h_gav_buffet = 0.15.

const L_MOLDURA = 0.05

export const ARMARIOS = {

  // ── ARM-MULT-A — Armário Multiuso 2 Portas de Giro ──────────────────────────
  // Entrada n_prat (default 4 em CalculadoraCusto.jsx). Prateleiras internas → branco.
  'Armário Multiuso 2 Portas': {
    entradas: ['C','P','A','n_prat'],
    pecas: [
      p('Lateral',           '15', v => v.P * v.A, 2),
      p('Tampo',             '15', v => v.C * v.P, 1),
      p('Base',              '15', v => v.C * v.P, 1, 'branco'),
      p('Prateleira',        '15', v => v.C * v.P, v => v.n_prat, 'branco'),
      p('Porta de giro',     '15', v => (v.C/2) * v.A, 2),
      p('Fundo do móvel',    '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 8, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── ARM-MULT-B — Armário Multiuso 1 Porta de Giro (Estreito) ────────────────
  'Armário Multiuso 1 Porta': {
    entradas: ['C','P','A','n_prat'],
    pecas: [
      p('Lateral',           '15', v => v.P * v.A, 2),
      p('Tampo',             '15', v => v.C * v.P, 1),
      p('Base',              '15', v => v.C * v.P, 1, 'branco'),
      p('Prateleira',        '15', v => v.C * v.P, v => v.n_prat, 'branco'),
      p('Porta de giro',     '15', v => v.C * v.A, 1),
      p('Fundo do móvel',    '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 4, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── ARM-VERT-A — Armário Copa (basculante superior + 2 portas giro) ─────────
  'Armário Copa': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                  '15', v => v.P * v.A, 2),
      p('Tampo',                    '15', v => v.C * v.P, 1),
      p('Base',                     '15', v => v.C * v.P, 1, 'branco'),
      p('Divisória horizontal',     '15', v => v.C * v.P, 1, 'branco'),
      p('Prateleira interna',       '15', v => v.C * v.P, 2, 'branco'),
      p('Porta basculante',         '15', v => v.C * 0.15, 1),
      p('Porta de giro',            '15', v => (v.C/2) * (v.A - 0.15), 2),
      p('Fundo do móvel',           '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 4, corredica: 0, pistao: 1, rodinha: 0, cabide: 0 },
  },

  // ── ARM-VERT-B — Armário com Nicho Central (nicho aberto = peças cor) ───────
  'Armário com Nicho Central': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                  '15', v => v.P * v.A, 2),
      p('Tampo',                    '15', v => v.C * v.P, 1),
      p('Base',                     '15', v => v.C * v.P, 1),
      p('Divisória horizontal',     '15', v => v.C * v.P, 2),
      p('Porta de giro superior',   '15', v => (v.C/2) * (v.A/3), 2),
      p('Porta de giro inferior',   '15', v => (v.C/2) * (v.A/3), 2),
      p('Fundo do móvel',           '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 8, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── ARM-VERT-C renomeado — 3 Andares Abertos + 2 Portas Basculantes ─────────
  // (Catálogo R3 trazia "com Base de Madeira"; a base era adicional terceirizado
  //  que não entrava no MDF, então removemos do nome.)
  'Armário 3 Andares e Portas Inferiores': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                          '15', v => v.P * v.A, 2),
      p('Tampo',                            '15', v => v.C * v.P, 1),
      p('Base',                             '15', v => v.C * v.P, 1),
      p('Prateleira (parte aberta)',        '15', v => v.C * v.P, 2),
      p('Divisória horizontal',             '15', v => v.C * v.P, 1),
      p('Prateleira interna (basculantes)', '15', v => v.C * v.P, 1, 'branco'),
      p('Porta basculante',                 '15', v => (v.C/2) * (v.A * 0.4), 2),
      p('Fundo do móvel',                   '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 2, rodinha: 0, cabide: 0 },
  },

  // ── SUSP-A — Suspenso com 2 Portas Basculantes e Nicho Duplo Central ────────
  // Nicho central aberto → divisória horizontal do nicho = cor (peça do nicho exposta).
  'Armário Suspenso 2 Basculantes e 2 Nichos': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                       '15', v => v.P * v.A, 2),
      p('Divisória vertical',            '15', v => v.P * v.A, 2),
      p('Tampo',                         '15', v => v.C * v.P, 1),
      p('Base',                          '15', v => v.C * v.P, 1, 'branco'),
      p('Divisória horizontal (nicho)',  '15', v => (v.C/3) * v.P, 1),
      p('Porta basculante',              '15', v => (v.C/3) * v.A, 2),
      p('Fundo do móvel',                '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 2, rodinha: 0, cabide: 0 },
  },

  // ── SUSP-B — Suspenso 2 Portas Giro + 1 Basculante + 1 Nicho (4 colunas) ────
  'Armário Suspenso 2 Portas e Basculante': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                  '15', v => v.P * v.A, 2),
      p('Divisória vertical',       '15', v => v.P * v.A, 3),
      p('Tampo',                    '15', v => v.C * v.P, 1),
      p('Base',                     '15', v => v.C * v.P, 1, 'branco'),
      p('Porta de giro',            '15', v => (v.C/4) * v.A, 2),
      p('Porta basculante',         '15', v => (v.C/4) * v.A, 1),
      p('Fundo do móvel',           '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 4, corredica: 0, pistao: 1, rodinha: 0, cabide: 0 },
  },

  // ── SUSP-C — Suspenso 3 Portas ──────────────────────────────────────────────
  'Armário Suspenso 3 Portas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                  '15', v => v.P * v.A, 2),
      p('Divisória vertical',       '15', v => v.P * v.A, 2, 'branco'),
      p('Tampo',                    '15', v => v.C * v.P, 1),
      p('Base',                     '15', v => v.C * v.P, 1, 'branco'),
      p('Porta de giro',            '15', v => (v.C/3) * v.A, 3),
      p('Fundo do móvel',           '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 6, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── SUSP-D — Suspenso 2 Portas + Nicho Duplo Lateral ────────────────────────
  'Armário Suspenso 2 Portas e Nicho': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                  '15', v => v.P * v.A, 2),
      p('Divisória vertical',       '15', v => v.P * v.A, 2),
      p('Tampo',                    '15', v => v.C * v.P, 1),
      p('Base',                     '15', v => v.C * v.P, 1),
      p('Prateleira nicho',         '15', v => (v.C/3) * v.P, 1),
      p('Porta de giro',            '15', v => (v.C/3) * v.A, 2),
      p('Fundo do móvel',           '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 4, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── SUSP-E — Suspenso 3 Portas + Nicho Duplo Lateral ────────────────────────
  'Armário Suspenso 3 Portas e Nicho': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                  '15', v => v.P * v.A, 2),
      p('Divisória vertical',       '15', v => v.P * v.A, 3),
      p('Tampo',                    '15', v => v.C * v.P, 1),
      p('Base',                     '15', v => v.C * v.P, 1),
      p('Prateleira nicho',         '15', v => (v.C/4) * v.P, 1),
      p('Porta de giro',            '15', v => (v.C/4) * v.A, 3),
      p('Fundo do móvel',           '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 6, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── SUSP-F — Suspenso 4 Portas ──────────────────────────────────────────────
  'Armário Suspenso 4 Portas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                  '15', v => v.P * v.A, 2),
      p('Divisória vertical',       '15', v => v.P * v.A, 3, 'branco'),
      p('Tampo',                    '15', v => v.C * v.P, 1),
      p('Base',                     '15', v => v.C * v.P, 1, 'branco'),
      p('Porta de giro',            '15', v => (v.C/4) * v.A, 4),
      p('Fundo do móvel',           '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 8, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── GEL-A — Gelágua com Fruteira (nichos abertos) ───────────────────────────
  'Móvel Gelágua com Fruteira': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',              '15', v => v.P * v.A, 2),
      p('Tampo',                '15', v => v.C * v.P, 1),
      p('Base',                 '15', v => v.C * v.P, 1),
      p('Divisória horizontal', '15', v => v.C * v.P, 2),
      p('Fundo do móvel',       '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── GEL-B — Gelágua Fechada (2 portas de giro) ──────────────────────────────
  'Móvel Gelágua Fechado': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                  '15', v => v.P * v.A, 2),
      p('Tampo',                    '15', v => v.C * v.P, 1),
      p('Base',                     '15', v => v.C * v.P, 1, 'branco'),
      p('Divisória horizontal',     '15', v => v.C * v.P, 1, 'branco'),
      p('Porta de giro superior',   '15', v => v.C * (v.A/2), 1),
      p('Porta de giro inferior',   '15', v => v.C * (v.A/2), 1),
      p('Fundo do móvel',           '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 4, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── AS-A — Armário Área de Serviço 2 Portas com Vassoureiro ─────────────────
  // Vassoureiro = compartimento vertical sem prateleiras (40% C). Prateleiras
  // ficam no lado oposto, 60% C. Tudo interno (atrás de portas fechadas) → branco.
  'Armário Área de Serviço 2 Portas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                       '15', v => v.P * v.A, 2),
      p('Tampo',                         '15', v => v.C * v.P, 1),
      p('Base',                          '15', v => v.C * v.P, 1, 'branco'),
      p('Divisória vassoureiro',         '15', v => v.P * v.A, 1, 'branco'),
      p('Prateleira (lado não-vass.)',   '15', v => (v.C * 0.6) * v.P, 4, 'branco'),
      p('Porta de giro',                 '15', v => (v.C/2) * v.A, 2),
      p('Fundo do móvel',                '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 8, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── AS-B — Armário Área de Serviço 1 Porta com Vassoureiro (estreito) ───────
  'Armário Área de Serviço 1 Porta': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                       '15', v => v.P * v.A, 2),
      p('Tampo',                         '15', v => v.C * v.P, 1),
      p('Base',                          '15', v => v.C * v.P, 1, 'branco'),
      p('Divisória vassoureiro',         '15', v => v.P * v.A, 1, 'branco'),
      p('Prateleira (lado não-vass.)',   '15', v => (v.C * 0.6) * v.P, 4, 'branco'),
      p('Porta de giro',                 '15', v => v.C * v.A, 1),
      p('Fundo do móvel',                '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 4, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── AS-C — Armário p/ Máquina Top Load (vão + comp. sup. com basculante 40cm) ─
  // 1 porta basculante superior + 1 prateleira interna. Vão inferior aberto
  // pra máquina Top Load (que carrega por cima).
  'Armário para Máquina Top Load': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                          '15', v => v.P * v.A, 2),
      p('Tampo',                            '15', v => v.C * v.P, 1),
      p('Base do compartimento superior',   '15', v => v.C * v.P, 1, 'branco'),
      p('Prateleira interna',               '15', v => v.C * v.P, 1, 'branco'),
      p('Porta basculante',                 '15', v => 0.40 * (v.A * 0.4), 1),
      p('Fundo do móvel',                   '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 1, rodinha: 0, cabide: 0 },
  },

  // ── AS-D — Armário p/ Máquina Front Load ────────────────────────────────────
  // Compartimento superior fechado com 2 portas de giro + prateleira interna
  // + nicho central vertical (entre as portas). Vão inferior aberto pra
  // máquina de lavar. Portas ~35% da largura cada; nicho ~30% no centro.
  'Armário para Máquina Front Load': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                          '15', v => v.P * v.A, 2),
      p('Tampo',                            '15', v => v.C * v.P, 1),
      p('Base do compartimento superior',   '15', v => v.C * v.P, 1, 'branco'),
      p('Prateleira interna',               '15', v => v.C * v.P, 1, 'branco'),
      // Divisórias verticais pro nicho central (2 pra criar o nicho no meio)
      p('Divisória vertical (nicho)',       '15', v => v.P * (v.A * 0.35), 2, 'branco'),
      // 2 portas de giro laterais (~35% da largura cada, 35% da altura)
      p('Porta de giro',                    '15', v => (v.C * 0.35) * (v.A * 0.35), 2),
      p('Fundo do móvel',                   '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 4, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── WC-A — Carrinho WC com 1 Porta Basculante (altura 35cm) ─────────────────
  'Carrinho WC com Porta Basculante': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',           '15', v => v.P * v.A, 2),
      p('Tampo',             '15', v => v.C * v.P, 1),
      p('Base',              '15', v => v.C * v.P, 1, 'branco'),
      p('Porta basculante',  '15', v => v.C * v.A, 1),
      p('Fundo do móvel',    '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 1, rodinha: 4, cabide: 0 },
  },

  // ── WC-C — Carrinho WC com Porta de Giro e Nicho Lateral ────────────────────
  'Carrinho WC com Porta e Nicho': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',              '15', v => v.P * v.A, 2),
      p('Divisória vertical',   '15', v => v.P * v.A, 1),
      p('Tampo',                '15', v => v.C * v.P, 1),
      p('Base',                 '15', v => v.C * v.P, 1),
      p('Porta de giro',        '15', v => (v.C/2) * v.A, 1),
      p('Fundo do móvel',       '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 2, corredica: 0, pistao: 0, rodinha: 4, cabide: 0 },
  },

  // ── WC-D — Carrinho WC Aberto (sem prateleira interna, sem portas) ──────────
  'Carrinho WC Aberto': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',           '15', v => v.P * v.A, 2),
      p('Tampo',             '15', v => v.C * v.P, 1),
      p('Base',               '15', v => v.C * v.P, 1),
      p('Fundo do móvel',    '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 4, cabide: 0 },
  },
}
